module.exports = __webpack_public_path__ + "static/media/livup.0e9bf408.png";